import React from "react";
import "../style/help.css";

export default function Help() {
  const handleLogout = async () => {
    const dialogLogoutUrl =
      location.protocol +
      "//" +
      location.hostname +
      (location.port ? ":" + location.port : "") +
      "/logout.html";
    Office.context.ui.displayDialogAsync(
      dialogLogoutUrl,
      { height: 40, width: 30 },
      async (result) => {
        if (result.status === Office.AsyncResultStatus.Failed) {
          displayError(`${result.error.code} ${result.error.message}`);
        } else {
          Office.Dialog = result.value;
          Office.Dialog.addEventHandler(
            Office.EventType.DialogMessageReceived,
            processLogoutMessage
          );
        }
      }
    );
  };

  const processLogoutMessage = () => {
    setTimeout(() => {
      Office.Dialog.close();
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }, 3000);
  };

  return (
    <div className="helpinfo">
      <h2>Velkommen</h2>
      <p>
        Dette verktøyet fungerer bare for dokumenter laget for å skrive lovkommentarer hos Karnov
        Group Norway.
      </p>
      <p>
        Verktøyet vil hjelpe deg å spesifisere plassering av noter, verifiserere lenker, og generelt
        strømlinjeforme forfatterprosessen.
      </p>
      <p>
        En guide til hvordan bruke verktøyet finner du her:{" "}
        <a
          href="https://newcolaw.sharepoint.com/:b:/r/sites/NewcoLawAS/Delte%20dokumenter/Forfatterportalen/hurtigguide.pdf"
          target="_blank"
        >
          Hurtigguide
        </a>
      </p>
      {/* <p>
        Klikk her for å se et eksempeldokument for å teste funksjonaliteten:{" "}
        <a
          href="https://newcolaw.sharepoint.com/:w:/s/KPortal/EejQnY366M9MsJI0TAPtMYMB4orf0S33JcwEyj6Vcaw5Wg?e=63rdb6"
          target="_blank"
        >
          Eksempeldokument
        </a>
      </p> */}
      <p>
        Sjekk vår{" "}
        <a href="https://support.karnov.no" target="_blank">
          kunnskapsbase
        </a>{" "}
        for nyttige tips og løsninger på ofte stilte spørsmål.
      </p>
      <p><b>NB: Lenkeverktøyet er midlertidig deaktivert pga tekniske problemer.</b></p>
      <button className="LogoutButton" onClick={() => handleLogout()}>
        Logg ut
      </button>
    </div>
  );
}
